import * as React from 'react'
import { useState } from 'react'
import styled from 'styled-components'
import { Icon } from '../../atoms/icon'
import { Button, ButtonGroup } from '../../atoms/button'
import { Form } from 'react-final-form'
import TextFieldItem from '../../molecules/text-field/text-field'
import HiddenFieldItem from '../../molecules/text-field/hidden-field'
import { Color, Size } from '../../../constants/app.constant'
import useGetState from '../../../hooks/use-get-state'
import { dispAge, calcAge } from '../report/utils'
import {
  composeValidators,
  required,
  sameValue,
  differentValue,
  alphabeticAndNumeric8,
} from '../../../utils/validator'
import { when } from '../../../utils/mixin'
import axios from 'axios'

export default () => {
  const {
    state: {
      auth,
      patient,
    },
  } = useGetState()

  const onSubmit = async (formValues: any) => {
    console.log(formValues)
    post(formValues.previousPassword, formValues.proposedPassword).then(() => {
      console.log('password changed');
    });
  }
  const [result, setResult] = useState();
  // パスワード変更
  const post = async (previousPassword: string, proposedPassword: string) => {
    try{
      const API_BASE_URL = String(process.env.REACT_APP_MOFF_API_URL)
      const axiosObj = (options?: any) => {
        return axios.create({
            baseURL: API_BASE_URL,
            headers: {
              Authorization: auth.user.idToken.jwtToken,
            },
          })
        }
      const response  = await axiosObj().post(
        `patients/${auth.user.idToken.payload['custom:userId']}/password_change`,
        { 
            previousPassword: previousPassword,
            proposedPassword: proposedPassword,
            accessToken: auth.user.accessToken.jwtToken,
        }
      )
      if (response) {
        console.log(response);
        if (response.status === 200) {
          setResult('パスワードを変更しました。');
        } else {
          setResult('パスワードを変更できませんでした。エラー' + response.status);
        }
      }
    } catch (e) {
      setResult('パスワードを変更できませんでした。現在のパスワードが正しいこと、変更後は現在と異なる英数字8文字以上で入力してください。もしくは、一定時間内の変更回数の上限に達している可能性があります。しばらく時間をあけて、お試し下さい。');
      throw e
    }
  } 

  return (
    <Wrapper>
      <PageContents>
      <PageTitle>
          <PageTitleName>パスワード変更</PageTitleName>
        </PageTitle>
        <UserDetail>
          <Icon.User size={`${Size.XLARGE}px`} color={Color.DARK_GRAY} />
          <UserName>
            {patient.username}
            さん
          </UserName>
          <Age>{dispAge(calcAge(patient.birthdayYmd))}</Age>
        </UserDetail>
        <Result>
          {result}
        </Result>
        <FormWrapper>
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              console.log(values);
              const errors: any = {}
              // 現在のパスワード
              errors.previousPassword = composeValidators(
                required('現在のパスワードを入力してください'),
                alphabeticAndNumeric8
              )(values.previousPassword)
              errors.proposedPassword = composeValidators(
                required('変更後のパスワードを入力してください'),
                alphabeticAndNumeric8,
              )(values.proposedPassword)
              errors.proposedConfirmPassword = composeValidators(
                required('変更後のパスワード(確認用)を入力してください'),
                alphabeticAndNumeric8,
              )(values.proposedConfirmPassword)
              // 現在のパスワードと変更後のパスワードは異なるかチェック
              errors.proposedPassword = composeValidators(
                differentValue(values.proposedPassword),
                alphabeticAndNumeric8,
              )(values.previousPassword)
              // 変更後のパスワードの一致チェック
              errors.proposedConfirmPassword = composeValidators(
                sameValue(values.proposedConfirmPassword),
                alphabeticAndNumeric8,
              )(values.proposedPassword)
              return errors
            }}
            initialValues={{
              patientId: auth.user.idToken.payload['custom:userId'],
            }}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <HiddenFieldItem
                  name="patientId"
                  type="hidden"
                  value={auth.user.idToken.payload['custom:userId']}
                />
                <FieldSet>
                  <TextFieldItem
                    name="previousPassword"
                    type="text"
                    label="現在のパスワード"
                    placeholder="現在のパスワードを入力"
                    vertical={true}
                    required={true}
                  />
                  <TextFieldItem
                    name="proposedPassword"
                    type="text"
                    label="変更後のパスワード"
                    placeholder="変更後のパスワードを入力"
                    vertical={true}
                    required={true}
                  />
                  <TextFieldItem
                    name="proposedConfirmPassword"
                    type="text"
                    label="変更後のパスワード(確認用)"
                    placeholder="変更後のパスワードを再度入力"
                    vertical={true}
                    required={true}
                  />
                </FieldSet>
                <ButtonGroup vertical css="width: 168px;margin: 30px auto;">
                  <Button primary>変更</Button>
                </ButtonGroup>
              </form>
            )}
          />
        </FormWrapper>
      </PageContents>
    </Wrapper>
  )
}

const Wrapper = styled.div``
const PageContents = styled.div``
const PageTitle = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
`

const PageTitleName = styled.div`
  font-size: ${Size.LARGE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const UserDetail = styled.div`
  margin: 8px;
  display: flex;
  align-items: center;
`

const UserName = styled.div`
  font-size: ${Size.BASE}px;
  margin-left: 8px;
  margin-right: 8px;
`
const Age = styled.div`
  font-size: ${Size.BASE}px;
`

const Result = styled.div`
  font-size: ${Size.BASE}px;
  margin-left: 8px;
  margin-right: 8px;
  color: red;
`

const FormWrapper = styled.div`
  padding: 20px 30px 0;
  div {
    flex-direction: column;
    flex-flow: column nowrap;
  }
`
const FieldSet = styled.div<{
  vertical?: boolean
}>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  padding: 0 30px;
  div {
    width: 100%;
  }
  ${when('vertical')(`
    flex-direction: column;
    align-items: start;
  `)};
`



// WEBPACK FOOTER //
// ./src/components/pages/password_change/contents.tsx